import { Navbar, Footer } from "@/components/Layout";
import { useListingFlow } from "@/contexts/ListingFlowContext";
import { useNavigate } from "react-router-dom";
import { BackButton } from "@/components/BackButton";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { filterCategories, categoryToListingType } from "@/lib/filterData";

export default function CreateListingStep1() {
  const { data, updateData } = useListingFlow();
  const navigate = useNavigate();

  const selectedCategory = filterCategories.find((c) => c.value === data.category);
  const subs = selectedCategory?.subs ?? [];
  const canContinue = data.category !== "" && (subs.length === 0 || true); // sub is optional

  const handleSelectCategory = (val: string) => {
    const cat = filterCategories.find((c) => c.value === val);
    updateData({
      category: val,
      subCategory: "",
      listingType: categoryToListingType[val] ?? null,
    });
    // If category has no sub-categories, do not auto-navigate so the user
    // can confirm. Stay on this step and let them press Fortsätt.
  };

  const handleSelectSub = (sub: string) => {
    updateData({ subCategory: data.subCategory === sub ? "" : sub });
  };

  const handleContinue = () => {
    navigate("/skapa-annons/detaljer");
  };

  return (
    <div className="flex min-h-screen flex-col bg-background">
      <Navbar />
      <div className="container max-w-lg flex-1 py-6">
        <BackButton fallback="/dashboard" />

        <h1 className="mb-2 font-display text-2xl font-bold text-foreground">
          Välj kategori
        </h1>
        <p className="mb-6 text-muted-foreground">
          Vad vill du sälja?
        </p>

        <div className="mb-6 space-y-2">
          <Label className="text-sm font-medium">Kategori</Label>
          <div className="grid grid-cols-2 gap-2">
            {filterCategories.map((c) => {
              const active = data.category === c.value;
              return (
                <button
                  key={c.value}
                  onClick={() => handleSelectCategory(c.value)}
                  className={`rounded-xl border p-3 text-left text-sm font-medium shadow-sm transition-all active:scale-[0.98] ${
                    active
                      ? "border-primary bg-primary text-primary-foreground"
                      : "border-border bg-card text-foreground hover:border-primary"
                  }`}
                >
                  {c.label}
                </button>
              );
            })}
          </div>
        </div>

        {selectedCategory && subs.length > 0 && (
          <div className="mb-6 space-y-2">
            <Label className="text-sm font-medium">
              Underkategori <span className="text-muted-foreground font-normal">(valfritt)</span>
            </Label>
            <div className="flex flex-wrap gap-2">
              {subs.map((sub) => {
                const active = data.subCategory === sub;
                return (
                  <button
                    key={sub}
                    onClick={() => handleSelectSub(sub)}
                    className={`rounded-full border px-3 py-1.5 text-sm transition-colors ${
                      active
                        ? "border-primary bg-primary text-primary-foreground"
                        : "border-border bg-card text-foreground hover:border-primary"
                    }`}
                  >
                    {sub}
                  </button>
                );
              })}
            </div>
          </div>
        )}

        <Button className="w-full" disabled={!canContinue} onClick={handleContinue}>
          Fortsätt
        </Button>
      </div>
      <Footer hideOnMobile />
    </div>
  );
}
